import * as yup from 'yup';

export const serialNumberSchema = yup.object().shape({
  serialNumber: yup.string().required('シリアルナンバーは必須です'),
});
